export default {
    texts: [
        {label:"Title", id:"title", isRequired:true},
        {label:"Meeting Date", id:"meetingDate", type: 'date', isRequired:true},
        {label:"Remarks", id:"remarks", type:'array'},
        // {label:"Next Hearing Remarks", id:"remarksNextHearing"},
    ],
    checkboxes: []
}
